import {
  CardTable,
  CardTableDataCol,
  CardTableRow,
  Tooltip,
  Typography,
  useRouter,
} from '@forgeglobal/design-framework'
import { ParticipantFragment, useGetOfferingParticipantsQuery } from 'graphql/bindings/AdminBindings'
import { Routes } from 'util/Routes'
import React, { useState } from 'react'

import { LoadingRow } from './CampaignParticipantsDetail'

interface CampaignParticipantsTableProps {
  offeringId: string
}

const PARTICIPANTS_PER_PAGE = 20

export const CampaignParticipantsTable: React.FC<CampaignParticipantsTableProps> = ({ offeringId }) => {
  const { history } = useRouter()
  const [emailTooltipText, setEmailTooltipText] = useState('Copy')
  const defaultTableVars = {
    id: offeringId,
    limit: PARTICIPANTS_PER_PAGE,
  }

  const { data, loading, refetch } = useGetOfferingParticipantsQuery({
    variables: {
      ...defaultTableVars,
      offset: 0,
    },
  })

  const participants = data?.offering.paginatedParticipants.data ?? []
  const count = data?.offering.paginatedParticipants.count
  const offset = data?.offering.paginatedParticipants.offset
  const limit = data?.offering.paginatedParticipants.limit

  const columnDefs = [
    {
      name: 'name',
      label: 'Account name',
      minWidth: 150,
      isLabelHidden: false,
    },
    {
      name: 'emailAddress',
      label: 'Email address',
      minWidth: 150,
      isLabelHidden: false,
    },
    {
      name: 'status',
      label: 'Status',
      minWidth: 150,
      isLabelHidden: false,
    },
  ]

  const handleClick = (email: string) => {
    navigator.clipboard.writeText(email).then(() => {
      setEmailTooltipText('Copied')
      setTimeout(() => {
        setEmailTooltipText('Copy')
      }, 1000)
    })
  }

  return (
    <CardTable
      colDefs={columnDefs}
      count={count}
      offset={offset}
      pageSize={limit}
      onPageChange={(newOffset: number) => {
        refetch({
          ...defaultTableVars,
          offset: newOffset,
        })
      }}>
      {participants.map((participant: ParticipantFragment) => {
        const { status, user } = participant
        const { name, email } = user
        const columns = {
          name: (
            <CardTableDataCol name="name">
              <Typography variant="subtitle2" onClick={() => history.push(Routes.account(user.crm_account.id))}>
                {name}
              </Typography>
            </CardTableDataCol>
          ),
          emailAddress: (
            <CardTableDataCol name="emailAddress">
              <Tooltip title={emailTooltipText} placement="left">
                <div>
                  <Typography variant="subtitle2" onClick={() => handleClick(email)}>
                    {email}
                  </Typography>
                </div>
              </Tooltip>
            </CardTableDataCol>
          ),
          status: (
            <CardTableDataCol name="status">
              <Typography variant="subtitle2">{status}</Typography>
            </CardTableDataCol>
          ),
        }
        return <CardTableRow key={email} id={email} columns={columns} />
      })}
      <LoadingRow isLoading={loading} />
    </CardTable>
  )
}
